module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300.woff?38bcfba2c37aac23453faf21d14511fb";